import { useMediaQuery, useTheme } from '@nexelem/deprecated-theme';
import { useConfig } from '@nexelem/config';
import { PropsWithChildren, createContext, useContext } from 'react';
import { useLocation } from 'react-router-dom';

const JumboContext = createContext<boolean | null>(null);

export const JumboProvider = ({ children }: PropsWithChildren) => {
  const {
    modules: {
      global: { jumboMode },
    },
  } = useConfig();
  const location = useLocation();
  const { breakpoints } = useTheme();
  const isJumboResolution = useMediaQuery(breakpoints.up('md'));
  const pathArray = location.pathname.split('/');
  // workstation report has pathArray length of 3,
  // anything more than that is nested path, which shouldn't be in jumbo mode
  const isJumbo = jumboMode && pathArray[1] === 'work-stations' && pathArray.length <= 3 && isJumboResolution;

  return <JumboContext.Provider value={isJumbo}>{children}</JumboContext.Provider>;
};

export const useIsJumbo = () => {
  const isJumbo = useContext(JumboContext);

  if (isJumbo === null) {
    throw new Error('JumboContext not found');
  }

  return isJumbo;
};
